module.exports = __webpack_public_path__ + "img/WEKIWI.504e3d7e.png";